import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22818264"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "background" }
const _hoisted_2 = { class: "contain" }
const _hoisted_3 = { class: "back-arrow" }
const _hoisted_4 = { class: "cityChartTitle" }
const _hoisted_5 = { class: "programTitle" }
const _hoisted_6 = ["id"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "查看详情", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  style: {"overflow-y":"auto","overflow-x":"hidden","max-height":"90%","width":"90%","margin":"0 auto","margin-top":"5%"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title1" }, " 专家意见 ", -1))
const _hoisted_12 = { class: "content1" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title2" }, " 相关文件 ", -1))
const _hoisted_14 = { class: "content2" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title2" }, " 相关照片 ", -1))
const _hoisted_16 = { class: "content2" }
const _hoisted_17 = { class: "demo-image__preview" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title1" }, " 问题描述 ", -1))
const _hoisted_20 = { class: "content1" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title2" }, " 整改建议 ", -1))
const _hoisted_22 = { class: "content2" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title3" }, " 问题照片 ", -1))
const _hoisted_24 = { class: "content3" }
const _hoisted_25 = { class: "demo-image__preview" }
const _hoisted_26 = {
  key: 0,
  id: "bodyContainer"
}
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "tab" }
const _hoisted_29 = { style: {"margin-top":"5px","border":"1px solid #a0a0a0","overflow":"auto"} }
const _hoisted_30 = ["innerHTML"]

import "@/font/css/font.css";
import { useRouter, useRoute } from 'vue-router'
import { ref, onMounted, onUpdated, watch } from 'vue'
import myDialog from '@/views/entryDetailsPages/myDialog.vue'
// import { init } from "echarts";
import javaapi from "@/service/javaapi";
import { forEach } from "lodash-es";
import { ElMessage, ElTable, valueEquals } from "element-plus";
import axios from "axios";
import { defaultOptions, renderAsync } from 'docx-preview'
import { fa, tr } from "element-plus/es/locale";
import * as XLSX from 'xlsx';

export default /*#__PURE__*/_defineComponent({
  __name: 'entryPages',
  setup(__props) {


const subjectItemTableRef = ref<InstanceType<typeof ElTable>>()
const refWord = ref(null)
let checkup_subject_id = ref(0)
let checkup_subject_name = ref('')
let organizationName = ref('')
const route = useRoute()
const env = process.env as any;
const host = env.VUE_APP_DB_URL;
onMounted(() => {
    init()
})
onUpdated(() => {
    let checkup_subject_item_id = parseInt(route.query.checkup_subject_item_id + '')
    if (checkup_subject_item_id !== 0) {
        
            let currentrowDiv = document.querySelector(`#item${checkup_subject_item_id}`);
            const currentrow = currentrowDiv?.parentElement?.parentElement
            const offsetHeight = currentrow?.offsetHeight
            const offsetTop = currentrow?.offsetTop
            const clientHeight = currentrow?.clientHeight
            subjectItemTableRef.value!.scrollTo({
                left:0,
                top:offsetHeight! + offsetTop! - clientHeight!,
                behavior: 'smooth'
            })
            let index = tableData.value.findIndex(data => data.checkup_subject_item_id === checkup_subject_item_id)
            subjectItemTableRef.value!.setCurrentRow(subjectItemTableRef.value!.data[index])
    }
})
const init = async () => {
    organizationName.value = route.query.organizationName + ''
    checkup_subject_name.value = route.query.checkup_subject_name + ''
    checkup_subject_id.value = parseInt(route.query.checkupSubjectId + '')
   
    const query = {
        size: 9999,
        entity: 'subjectItem',
        interface: 'getItemsInfo',
    }
    const selector = {
        checkup_subject_id: checkup_subject_id.value,
        token: localStorage.getItem('token'),
        user_id: localStorage.getItem('user_id')
    }
    let result = await javaapi.list(query, selector)
    //console.log('result', result)
    tableData.value.length = 0
    tableData.value = [...result.subjectItemDTOes]
    // console.log("表格",  tableData.value);

}

const count = ref(2)
const load = () => {
    count.value += 2
}

const rowState = (arg) => {
    return {
        backgroundColor: '#0d277b',
        color: '#fff',
        fontSize: '16px',
    }
}

const indexMethod = (index: number) => {
    return index + 1;
}


const dialogVisible = ref(false)
const itemEvaluation = ref([
    {
        "checkup_subject_item_evaluation_id": 0,
        "checkup_subject_item_id": 0,
        "problem_description": "",
        "checkup_evaluation_improve_suggest": "",
        "checkup_item_evaluation_inspection_result": '',
        "is_positive": 1,
    }
])

const clickButton = async (checkup_subject_item_id) => {
    const query = {
        size: 9999,
        entity: 'subjectItem',
        interface: 'getItemEvaluation',
    }
    const selector = {
        checkup_subject_item_id: checkup_subject_item_id,
        token: localStorage.getItem('token'),
        user_id: localStorage.getItem('user_id')
    }
    let result = await javaapi.list(query, selector)
    //console.log('result', result)
    itemEvaluation.value.length = 0
    // console.log(result.subjectEvaluationDTOes);

    if (result.subjectEvaluationDTOes.length != 0) {
        if (localStorage.getItem('is_positive') == '2') {
            itemEvaluation.value = [...result.subjectEvaluationDTOes]
        } else {
            result.subjectEvaluationDTOes.forEach((data) => {
                if (data.is_positive == parseInt(<string>localStorage.getItem('is_positive'))) {
                    itemEvaluation.value.push(data)
                }
            });
        }
    }
    console.log("itemEvaluation", itemEvaluation.value);

    if (itemEvaluation.value.length == 0) {
        ElMessage.info("暂无材料")
        return
    }

    await getFileList(0)
    dialogVisible.value = true
    //TODO:显示
}
const srcList = ref([''])
const imageSrcList = ref([''])
const currentIndex = ref(0)
// const isShowImage = ref(false)
// const clickImage = () => {
//     isShowImage.value = true
// }
// const closeImage = () => {
//     isShowImage.value = false
// }

const getFileList = async (index) => {

    files.value.length = 0;
    images.value.length = 0;
    imageSrcList.value.length = 0;
    setTimeout(async () => {
        if (itemEvaluation.value[index].is_positive == 1) {
            const query = {
                jsonText: { "checkup_subject_item_evaluation_id": itemEvaluation.value[index].checkup_subject_item_evaluation_id },
                token: localStorage.getItem('token'),
                user_id: localStorage.getItem('user_id'),
            }

            let fileResult = await javaapi.postQuery(query, '/file/getFileList')
            if (fileResult.status == 1) {
                files.value = [...fileResult.data.checkupProjectFileList]
                //console.log("文件", files.value)
            }

            let imageResult = await javaapi.postQuery(query, '/file/getImageList')
            if (imageResult.status == 1) {
                images.value = [...imageResult.data.checkupProjectFileList]
                imageSrcList.value = images.value.map(data => host + data.file_url)
            }

        } else if (itemEvaluation.value[index].is_positive == 0) {
            const query = {
                jsonText: { "checkup_subject_item_evaluation_id": itemEvaluation.value[index].checkup_subject_item_evaluation_id },
                token: localStorage.getItem('token'),
                user_id: localStorage.getItem('user_id'),
            }

            let fileResult = await javaapi.postQuery(query, '/file/getImageList')
            if (fileResult.status == 1) {
                files.value = [...fileResult.data.checkupProjectFileList]
                //console.log("图片", files)
                srcList.value.length = 0;
                files.value.forEach(data => {
                    srcList.value.push(host + data.file_url)
                })
                //console.log(srcList.value)
            }

        }
    }, 500)


}


//console.log(defaultOptions);
const docxOptions = ref({
    className: "kaimo-docx-666", // string：默认和文档样式类的类名/前缀
    inWrapper: true, // boolean：启用围绕文档内容的包装器渲染
    ignoreWidth: false, // boolean：禁用页面的渲染宽度
    ignoreHeight: false, // boolean：禁止渲染页面高度
    ignoreFonts: false, // boolean：禁用字体渲染
    breakPages: true, // boolean：在分页符上启用分页
    ignoreLastRenderedPageBreak: true, // boolean：在 lastRenderedPageBreak 元素上禁用分页
    experimental: false, // boolean：启用实验功能（制表符停止计算）
    trimXmlDeclaration: true, // boolean：如果为true，解析前会从​​ xml 文档中移除 xml 声明
    useBase64URL: false, // boolean：如果为true，图片、字体等会转为base 64 URL，否则使用URL.createObjectURL
    useMathMLPolyfill: false, // boolean：包括用于 chrome、edge 等的 MathML polyfill。
    showChanges: false, // boolean：启用文档更改的实验性渲染（插入/删除）
    debug: false, // boolean：启用额外的日志记录

})
// 实现文件下载
//原文链接：https://blog.csdn.net/qq_43705697/article/details/123960369

//
const isopenDocx = ref(false)
const isDocx = ref(false)
const isExcel = ref(false)
const options = {
    container: 'bodyContainer', //容器id名
    title: '测试Excel', // 表 头名
    lang: 'zh', // 中文
    showtoolbar: true, // 是否显示工具栏
    showinfobar: false, // 是否显示顶部信息栏
    showsheetbar: true // 是否显示底部sheet按钮
}
const excel = ref({
    // 数据
    workbook: {},
    // 表名称集合
    sheetNames: [''],
    // 激活项
    sheetNameActive: "",
    // 当前激活表格
    SheetActiveTable: ""

})

const downloadFile = (url, file_name) => {
    // window.open('http://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(url), "_blank")
    // console.log(encodeURIComponent(url))
    isopenDocx.value = true;
    if (file_name.includes("docx")) {
        isDocx.value = true
        fetch(url).then((res) => {
            let bodyContainer = <HTMLElement>document.getElementById("bodyContainer");

            res.blob().then((blob) => {
                if (file_name.includes('docx')) {
                    renderAsync(
                        blob, // Blob | ArrayBuffer | Uint8Array, 可以是 JSZip.loadAsync 支持的任何类型
                        bodyContainer, // HTMLElement 渲染文档内容的元素,
                        bodyContainer, // HTMLElement, 用于呈现文档样式、数字、字体的元素。如果为 null，则将使用 bodyContainer。
                        docxOptions.value // 配置
                    ).then(res => {
                        //console.log("res---->", res)
                    });
                }
            });
        });
    }

    //表格

    // 版权声明：本文为CSDN博主「light多记一点」的原创文章，遵循CC 4.0 BY-SA版权协议，转载请附上原文出处链接及本声明。
    // 原文链接：https://blog.csdn.net/lucklymm/article/details/128126001
    if (file_name.includes('xlsx')) {
        // window.open('http://view.officeapps.live.com/op/view.aspx?src=' + url, "_self")
        isExcel.value = true
        //表格
        axios.request({
            method: "GET",
            url: url, //路径
            responseType: "arraybuffer", //告诉服务器想到的响应格式
        }).then(({ data }) => {
            //console.log(data, 'data');
            if ({ data }) {
                const workbook = XLSX.read(data, {
                    type: "buffer",
                });
                //console.log(workbook, 'workbook');
                const sheetNames = workbook.SheetNames // 工作表名称集合
                excel.value.workbook = workbook
                excel.value.sheetNames = sheetNames
                excel.value.sheetNameActive = sheetNames[0]
                //console.log(excel.value, 'excel.value');
                getSheetNameTable(sheetNames[0])
            } else {
                ElMessage.error({ message: "接口请求失败" });

            }
        })
            .catch(function (error) {
                ElMessage.error({ message: "接口请求失败" });
                //console.log(error);
            });
    }


}

const emptyTips = ref('暂无内容');
const getSheetNameTable = (sheetName) => {
    try {
        // 获取当前工作表的数据
        const worksheet = excel.value.workbook.Sheets[sheetName]
        //console.log('worksheet',worksheet);
        // 转换为数据  1.json数据有些问题，2.如果是html那么样式需修改
        //console.log(XLSX.utils.sheet_to_json(worksheet))
        let htmlData = XLSX.utils.sheet_to_html(worksheet, { header: '', footer: '' })
        htmlData = htmlData === '' ? htmlData : htmlData.replace(/<table/, '<table class="default-table" border="1px solid #ccc" cellpadding="0" cellspacing="0"')
        // 第一行进行改颜色
        htmlData = htmlData === '' ? htmlData : htmlData.replace(/<tr/, '<tr style="background:#b4c9e8"')
        excel.value.SheetActiveTable = htmlData
    } catch (e) {
        // 如果工作表没有数据则到这里来处理
        excel.value.SheetActiveTable = '<h4 style="text-align: center">' + emptyTips.value + '</h4>'
    }
}

const handleClose = () => {
    isExcel.value = false
    isDocx.value = false
    isopenDocx.value = false
}



const handleChange = (newIndex, oldIndex) => {
    //console.log(oldIndex, newIndex)
    getFileList(newIndex)
}

const tableData = ref([
    {
        "checkup_subject_item_id": 0,
        "organization_id": 0,
        "checkup_subject_id": 0,
        "checkup_item_name": "",
        "checkup_item_evaluation_content": "",
        "checkup_item_basic_score": 0,
        "checkup_category_name": "",
    }
])

// 专家意见
const expertOpinionText = ref<string>(
    '企业应建立异常状况的设备设施应急处置机制，' +
    '对设备设置出现各种异常状况后可能造成的后果进行预判，并制定相应处置程序、明确责任人。' +
    '建立了完备的设备自动化保护系统，如超限联锁自动停车系统、人为紧急停车系统等。' +
    '加强工艺报警管理，加强了对异常工况的监控和处置管理，建立并实施设备完好性管理体系管理，提高工艺及设备运行的安全性、可靠性、完好性，尽量减少和避免生产设备出现异常状况。'
)

// 相关文件
const files = ref([
    {
        file_name: '',
        file_url: ''
    }
])

const images = ref([
    {
        file_name: '',
        file_url: ''
    }
])


const router = useRouter()

const back = () => {
    router.go(-1);

}

return (_ctx: any,_cache: any) => {
  const _component_Back = _resolveComponent("Back")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_icon, {
          onClick: back,
          style: {"color":"white","font-size":"1.8vw","cursor":"pointer"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Back)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(organizationName)), 1),
      _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(checkup_subject_name)), 1),
      _createVNode(_unref(ElTable), {
        class: "table",
        ref_key: "subjectItemTableRef",
        ref: subjectItemTableRef,
        height: "85%",
        data: tableData.value,
        style: {"width":"90%","--el-table-border-color":"#2384DD"},
        "header-cell-style": { background: '#144295', color: '#fff', fontSize: '20px' },
        "highlight-current-row": "",
        "row-style": rowState,
        "row-key": "checkup_subject_item_id"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "index",
            label: "序号",
            "min-width": "5%",
            index: indexMethod,
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "checkup_category_name",
            label: "类别",
            "min-width": "25%",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "checkup_item_name",
            label: "项目",
            "min-width": "20%",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "checkup_item_evaluation_content",
            label: "评估内容",
            "min-width": "30%",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "实际得分",
            "min-width": "15%",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", {
                id: 'item' + scope.row.checkup_subject_item_id
              }, _toDisplayString(scope.row.checkup_item_evaluation_actual_score) + "/" + _toDisplayString(scope.row.checkup_item_basic_score), 9, _hoisted_6)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "material",
            label: "支撑材料",
            "min-width": "15%",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", {
                class: "detailButton",
                onClick: ($event: any) => (clickButton(scope.row.checkup_subject_item_id))
              }, _hoisted_9, 8, _hoisted_7)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createVNode(myDialog, {
        "dialog-visible": dialogVisible.value,
        onCloseDialog: _cache[0] || (_cache[0] = ($event: any) => (dialogVisible.value = false))
      }, {
        content: _withCtx(() => [
          _createVNode(_component_el_carousel, {
            height: "58vh",
            "indicator-position": "outside",
            autoplay: false,
            trigger: "click",
            onChange: handleChange
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemEvaluation.value, (item) => {
                return (_openBlock(), _createBlock(_component_el_carousel_item, {
                  key: item.checkup_subject_item_evaluation_id
                }, {
                  default: _withCtx(() => [
                    (item.is_positive == 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _hoisted_11,
                          _createElementVNode("div", _hoisted_12, _toDisplayString(item.checkup_item_evaluation_inspection_result ==
                                        '' ? '无' : item.checkup_item_evaluation_inspection_result), 1),
                          _hoisted_13,
                          _createElementVNode("div", _hoisted_14, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, (file) => {
                              return (_openBlock(), _createElementBlock("div", null, [
                                (!file.file_name.includes('pdf'))
                                  ? (_openBlock(), _createBlock(_component_el_popover, {
                                      key: 0,
                                      placement: "right",
                                      width: 400,
                                      trigger: "hover"
                                    }, {
                                      reference: _withCtx(() => [
                                        _createVNode(_component_el_link, {
                                          ref_for: true,
                                          ref_key: "refWord",
                                          ref: refWord,
                                          type: "primary",
                                          href: _unref(host) + file.file_url,
                                          target: "_blank"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(file.file_name), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["href"])
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_button, {
                                          onClick: ($event: any) => (downloadFile(_unref(host) + file.file_url, file.file_name))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("预览文件")
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true),
                                (file.file_name.includes('pdf'))
                                  ? (_openBlock(), _createBlock(_component_el_link, {
                                      key: 1,
                                      ref_for: true,
                                      ref_key: "refWord",
                                      ref: refWord,
                                      type: "primary",
                                      href: _unref(host) + file.file_url,
                                      target: "_blank"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(file.file_name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["href"]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 256))
                          ]),
                          _hoisted_15,
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(images.value, (file, index) => {
                                return (_openBlock(), _createBlock(_component_el_image, {
                                  style: {"width":"130px","height":"130px","margin-right":"10px"},
                                  src: _unref(host) + file.file_url,
                                  "zoom-rate": 1.2,
                                  "preview-src-list": imageSrcList.value,
                                  "initial-index": index,
                                  fit: "fill",
                                  "preview-teleported": true
                                }, null, 8, ["src", "preview-src-list", "initial-index"]))
                              }), 256))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (item.is_positive == 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _hoisted_19,
                          _createElementVNode("div", _hoisted_20, _toDisplayString(item.problem_description == '' ? '无' : item.problem_description), 1),
                          _hoisted_21,
                          _createElementVNode("div", _hoisted_22, _toDisplayString(item.checkup_evaluation_improve_suggest ==
                                        '' ? '无' : item.checkup_evaluation_improve_suggest), 1),
                          _hoisted_23,
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, (file, index) => {
                                return (_openBlock(), _createBlock(_component_el_image, {
                                  style: {"width":"130px","height":"130px","margin-right":"10px"},
                                  src: _unref(host) + file.file_url,
                                  "zoom-rate": 1.2,
                                  "preview-src-list": srcList.value,
                                  "initial-index": index,
                                  fit: "fill",
                                  "preview-teleported": true
                                }, null, 8, ["src", "preview-src-list", "initial-index"]))
                              }), 256))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["dialog-visible"]),
      _createVNode(_component_el_dialog, {
        modelValue: isopenDocx.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isopenDocx).value = $event)),
        "before-close": handleClose,
        "append-to-body": true
      }, {
        default: _withCtx(() => [
          (isopenDocx.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26))
            : _createCommentVNode("", true),
          (isExcel.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_el_radio_group, {
                    size: "small",
                    modelValue: excel.value.sheetNameActive,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((excel.value.sheetNameActive) = $event)),
                    onChange: getSheetNameTable
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(excel.value.sheetNames, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_radio_button, {
                          key: index,
                          label: item
                        }, null, 8, ["label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", {
                    innerHTML: excel.value.SheetActiveTable,
                    style: {"padding":"10px 15px"}
                  }, null, 8, _hoisted_30)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})